import { Component } from '@angular/core';
import { ViewController, NavParams, NavController } from 'ionic-angular';
import { BettingService } from '../../services/betting.service';
import { AlertService } from '../../providers/alert.service';
import { BettingChase } from './bettingchase';
import { PlayDetailModel } from '../../models/betting.model';
import { CurrIssue } from '../../models/bettingorder.dto';
import { PageDefault } from '../PageDefault';
import { AppConfig } from '../../app/app.config'

@Component({
    selector: 'betting-add',
    templateUrl: 'bettingorderadd.html',
    providers: [BettingService]
})
export class BettingOrderAdd {
    para = {
        orders: [],
        lotteryName: "",
        lotteryCode: "",
        currIssue: new CurrIssue(),
        playDetail: new PlayDetailModel(),
        adjustReward: 0,
        rewardUp: 0,
        rewardDown: 0,
        baseReward: 0,
        currUserMoney: 0
    };
    AppConfig = AppConfig;
    bettingMoneys: number = 0;
    formatRemain = "00:00:00";
    setIntervalid : any;
    constructor(
        private viewCtrl: ViewController,
        private navpar: NavParams,
        private bettingService: BettingService,
        private alertService: AlertService,
        private navCtrl: NavController) {
        this.para = this.navpar.data;
        // if (this.checkPlayHasMultiRule(this.para.orders)) {
        //     this.para.hasMultiRule = true;
        // } else {
        //     this.para.hasMultiRule = false;
        // }
        this.getMoneys();
    }

    //计算订单总额
    //TQQ 2017-02-14
    getMoneys() {
        this.bettingMoneys = 0;
        if (this.para.orders.length > 0) {
            this.para.orders.forEach(s => {
                let money = s.bettingCount * s.multiple * s.perBettingPrice * s.yuanjiaofen;
                this.bettingMoneys += money;
            });
        } else {
            this.bettingMoneys = 0;
        }
    }


    //首次加载/返回
    //TQQ 2017-02-10
    ionViewDidEnter() {
         this.setIntervalid = setInterval(s => {
            this.para.currIssue.RemainTime -= 1000;
            this.issueTimerCallback(this.para.currIssue.RemainTime);
        }, 1000);
    }

    //TQQ 2017-02-22
    ionViewDidLeave() {
        clearInterval(this.setIntervalid);
    }


    //确认投注
    //TQQ 2017-01-10
    submitBettingOrder() {
        if (this.para.orders.length < 1) {
            this.alertService.showAlert("请选择号码");
            return;
        }
        var errors = [];
        let ajaxList = [];
        this.para.orders.forEach(o => {
            var b = {
                BettingCount: o.bettingCount,
                BettingMoney:(o.bettingCount * o.multiple * o.yuanjiaofen * o.perBettingPrice).toFixed(4),
                BettingNumber: o.selectNum,
                GraduationCount: o.GraduationCount,
                IsChaseNo: false,
                IssueNo: this.para.currIssue.CurrentIssueNo,
                LotteryCode: this.para.lotteryCode,
                LotteryPlayDetailCode: o.lotteryPlayDetailCode,
                Multiple: o.multiple,
                RuleName: o.ruleName,
                SelectMedian: o.SelectMedian,
                BettingInfoIssueList: [{
                    IssueNo: this.para.currIssue.CurrentIssueNo,
                    Multiple: o.multiple,
                    PerPrice: o.perBettingPrice * o.yuanjiaofen
                }],
                BuyIssueCount: 0
            };
            b.BuyIssueCount = b.BettingInfoIssueList.length;
            ajaxList.push(this.bettingService.betting(b));
        });
        ajaxList.forEach(r => {
            r.then(s => {
                if (!s.Result) {
                    errors.push(s);
                }
            });
        });
        Promise.all(ajaxList).then(() => {
            if (errors.length > 0) {
                var errorhtml = [];
                errors.forEach(e => {
                    errorhtml.push(e.Error);
                });
                this.alertService.showAlert(errorhtml.join(''));
            } else {
                this.alertService.showAlert("投注成功");
                this.viewCtrl.data = { "isBetting": true };
                this.viewCtrl.dismiss();
            }
        });

    }

    //删除投注订单
    //TQQ 2017-01-10
    delorder(o) {
        var index = this.para.orders.indexOf(o);
        if (index > -1) {
            this.para.orders.splice(index, 1);
        }
        this.getMoneys();
    }

    //清空所有
    //TQQ 2017-01-11
    clearAll() {
        // this.para.orders.forEach(o => {
        //     var index = this.para.orders.indexOf(o);
        //     if (index > -1) {
        //         this.para.orders.splice(index, 1);
        //     }
        // });
        this.para.orders=[];
        this.bettingMoneys=0;
         this.viewCtrl.data = { "isBetting": true };
    }

    //我要追号
    //TQQ 2017-01-11
    chaseClick() {
        if (this.checkPlayHasMultiRule(this.para.orders)) {
            this.alertService.showAlert("不可追号！");
            return;
        }
        if (this.InvestSumNum() <= 0) {
            this.alertService.showAlert("投注列表没有可以追号的订单！");
            return;
        }
        if (this.para.orders.length != 1) {
            this.alertService.showAlert("多注单不可追号！");
            return;
        }
        var para = {
            playType: 0,
            currIssue: this.para.currIssue,
            order: this.para.orders[0],
            lotteryCode: this.para.lotteryCode,
            lotteryName: this.para.lotteryName,
            playDetail: this.para.playDetail,
            adjustReward: this.para.adjustReward,
            rewardUp: this.para.rewardUp,
            rewardDown: this.para.rewardDown,
            baseReward: this.para.baseReward
        }
        this.navCtrl.push(BettingChase, para);
    }


    //检查是否添加的投注是否有多种玩法
    checkPlayHasMultiRule(betData) {
        if (!Array.isArray(betData)) {
            return;
        }
        var isMulti = false;
        var checkData = [];
        var checkDataLength = 0;
        betData.forEach(s => {
            checkData[s.lotteryPlayDetailCode] = true;
        });
        checkData.forEach(s => {
            ++checkDataLength;
        });
        if (checkDataLength > 1) {
            isMulti = true;
        }
        return isMulti;
    }

    InvestSumNum() {
        var count = 0;
        for (var i = 0; i < this.para.orders.length; i++) {
            count += this.para.orders[i].bettingCount;
        }
        return count;
    }



    //开奖倒计时
    //TQQ 2017-02-22
    issueTimerCallback(time) {
        if (time > 0) {
            let t = PageDefault.formatTime(time / 1000);
            this.formatRemain = t.join(':');
        } else {
            clearInterval(this.setIntervalid);
            this.alertService.showAlert("您好，" + this.para.currIssue.CurrentIssueNo + "期已截止，投注时请确认您选择的期号。");
            this.getIssue();
        }
    }

    //获取当前期号，当前期号结束剩余时间
    //TQQ 2017-02-22
    getIssue() {
        this.bettingService.getIssue(this.para.lotteryCode).then(s => {
            this.para.currIssue = s;
            this.setIntervalid = setInterval(s => {
                this.para.currIssue.RemainTime -= 1000;
                this.issueTimerCallback(this.para.currIssue.RemainTime);
            }, 1000);
        });
    }

}


// WEBPACK FOOTER //
// ./src/pages/bettingorder/bettingorderadd.ts